import { InjectionToken } from '@angular/core';

export type { WindowWithSession } from '../types/window-with-session';

export const WINDOW = new InjectionToken<Window>(
  'Window token to inject for easier stubbing in tests',
  { factory: () => window }
);
